import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import OfficialsList from '@/views/officials/List.vue';
import OfficialProfile from '@/views/officials/Profile.vue';
import UserRoles from '@/views/roles/roleAddUser.vue';

export const officialListRoute: RouteConfig = {
  path: 'officials',
  name: 'officials',
  component: OfficialsList,
  beforeEnter: (to, from, next) => {
    store
      .dispatch('officials/list', baseFilters(to))
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Operatorzy', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy operatorów.' }));
  }
};

export const officialDetailsRoute: RouteConfig = {
  path: 'officials/:id',
  name: 'official',
  component: OfficialProfile,
  beforeEnter: (to, from, next) => {
    store.commit('officials/setId', to.params.id);

    store
      .dispatch('officials/get')
      .then(res => {
        store.commit('breadcrumbs/set', [
          { text: 'Operatorzy', to: { name: 'officials' }, exact: true },
          { text: res.firstName + ' ' + res.lastName, disabled: true }
        ]);

        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych urzędnika' }));
  },
  meta: {
    toolbarTitle: 'Profil urzędnika'
  }
};

export const officialRolesRoute: RouteConfig = {
  path: 'officials/roles/:id',
  name: 'officialRoles',
  component: UserRoles,
  beforeEnter: (to, from, next) => {
    store.commit('officials/setId', to.params.id);
    Promise.all([
      store.dispatch(`profiles/userRole/list`, to.params.id),
      store.dispatch(`roles/list`, { count: 0 }),
      store.dispatch('officials/get').then(res => {
        store.commit('breadcrumbs/set', [
          { text: 'Operatorzy', to: { name: 'officials' }, exact: true },
          { text: res.firstName + ' ' + res.lastName, disabled: true },
          { text: 'Role', disabled: true }
        ]);
      })
    ])
      .then(() => next())
      .catch(error => {
        store.dispatch('notifyError', { title: 'Nie udało się pobrać danych urzędnika' });
      });
  },
  meta: {
    toolbarTitle: 'Drzewo ról użytkownika'
  }
};
